@if (processForm()) {
<form [formGroup]="processForm()">
    <div class="form-group row mb-3">
        <label class="col-md-4 col-form-label">Slug</label>
        <div class="col-md-8">
            @if (mode() === formMode.CREATE) {
                <input type="text" class="form-control text-uppercase" formControlName="slug"
                    placeholder="EJ. TRANSFER" (blur)="processForm().get('slug')?.setValue(($any($event.target).value || '').toUpperCase())">
                @if (processForm().get('slug')?.errors?.['required'] && processForm().get('slug')?.touched) {
                    <div><small class="text-danger">El slug es requerido.</small></div>
                }
                @if (processForm().get('slug')?.errors?.['pattern'] && processForm().get('slug')?.touched) {
                    <div><small class="text-danger">Use UPPER_SNAKE (letras, números y _).</small></div>
                }
            } @else {
                <div class="form-group mb-0">
                    <strong><code>{{ processForm().get('slug')?.value }}</code></strong>
                    <div class="form-text small">El identificador slug no se puede cambiar.</div>
                </div>
            }
        </div>
    </div>

    <div class="form-group row mb-3">
        <label class="col-md-4 col-form-label">Nombre</label>
        <div class="col-md-8">
            <input type="text" class="form-control" formControlName="name" placeholder="Ej. Transferencia de Socio">
            @if (processForm().get('name')?.errors?.['required'] && processForm().get('name')?.touched) {
                <div><small class="text-danger">El nombre es requerido.</small></div>
            }
        </div>
    </div>

    <div class="form-group row mb-3">
        <label class="col-md-4 col-form-label">Abreviatura</label>
        <div class="col-md-8">
            <input type="text" class="form-control" formControlName="abbr" placeholder="Ej. TRS">
        </div>
    </div>

    <div class="form-group row mb-3">
        <label class="col-md-4 col-form-label">Categoría</label>
        <div class="col-md-8">
            <select class="form-select" formControlName="category">
                <option [ngValue]="null">Seleccione categoría...</option>
                @for (cat of categories(); track cat.value) {
                    <option [ngValue]="cat.value">{{ cat.label }}</option>
                }
            </select>
            @if (processForm().get('category')?.errors?.['required'] && processForm().get('category')?.touched) {
                <div><small class="text-danger">La categoría es requerida.</small></div>
            }
        </div>
    </div>

    <div class="form-group row mb-3">
        <label class="col-md-4 col-form-label">Registro contable</label>
        <div class="col-md-8">
            <select class="form-select" formControlName="settlementTarget">
                @for (opt of settlementTargets; track opt.value) {
                    <option [ngValue]="opt.value">{{ opt.label }}</option>
                }
            </select>
            <div class="form-text small">
                Al aprobar el flujo: dónde se crea el movimiento (o ninguno).
            </div>
        </div>
    </div>

    <div class="form-group row mb-3">
        <label class="col-md-4 col-form-label">Reglas del proceso</label>
        <div class="col-md-8">
            @if (mode() === formMode.VIEW) {
                <div class="form-group mb-0">
                    @if ((processForm().get('ruleMap')?.value || []).length) {
                        <code>{{ (processForm().get('ruleMap')?.value || []).join(', ') }}</code>
                    } @else {
                        <span class="text-muted">Sin reglas asociadas</span>
                    }
                </div>
            } @else {
                <ng-select
                    [items]="ruleOptions()"
                    bindLabel="label"
                    bindValue="slug"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    [searchable]="true"
                    formControlName="ruleMap"
                    placeholder="Seleccione reglas (slugs)...">
                </ng-select>
                <div class="form-text small">
                    Solo estas reglas aplican a este proceso (como requisitos de documentos).
                </div>
            }
        </div>
    </div>

    <div class="form-group row mb-3">
        <label class="col-md-4 col-form-label">Módulos</label>
        <div class="col-md-8">
            <div class="form-check mb-2">
                <input class="form-check-input" type="checkbox" id="usesBpm" formControlName="usesBpm"
                    [disabled]="mode() === formMode.VIEW">
                <label class="form-check-label" for="usesBpm">
                    Usa flujo BPM
                </label>
                <div class="form-text small">Aparece en Configuración → Flujos BPM.</div>
            </div>
            <div class="form-check">
                <input class="form-check-input" type="checkbox" id="requiresDocuments" formControlName="requiresDocuments"
                    [disabled]="mode() === formMode.VIEW">
                <label class="form-check-label" for="requiresDocuments">
                    Usa requisitos de documentos
                </label>
                <div class="form-text small">Aparece en Configuración → Documentos.</div>
            </div>
            <div class="form-check mt-2">
                <input class="form-check-input" type="checkbox" id="groupSession" formControlName="groupSession"
                    [disabled]="mode() === formMode.VIEW">
                <label class="form-check-label" for="groupSession">
                    Agrupar en la sesión
                </label>
                <div class="form-text small">En la reunión se votan juntas y se muestran como una lista.</div>
            </div>
        </div>
    </div>

    <div class="form-group row mb-3">
        <label class="col-md-4 col-form-label">Icono (FontAwesome)</label>
        <div class="col-md-8">
            <div class="input-group">
                <span class="input-group-text">
                    <i [class]="processForm().get('icon')?.value || 'fas fa-cog'"></i>
                </span>
                <input type="text" class="form-control" formControlName="icon" placeholder="Ej. fas fa-exchange-alt">
            </div>
            <div class="form-text small">Clase CSS de FontAwesome (ej: <code>fas fa-exchange-alt</code>)</div>
        </div>
    </div>
</form>
}
